import { EMPTY_STRING } from '@e-socna/empty';

export interface ThirdPartyNames {
  readonly name?: string | null;
  readonly tradingName?: string | null;
  readonly lastName?: string | null;
  readonly firstName?: string | null;
}

const collator = new Intl.Collator('fr', {
  numeric: true,
  sensitivity: 'base',
});

// An organization by its company then trading name, a person by its last then
// first name.
const sortKeyOf = ({
  name,
  tradingName,
  lastName,
  firstName,
}: Readonly<ThirdPartyNames>): readonly string[] =>
  lastName
    ? [lastName, firstName ?? EMPTY_STRING]
    : [name ?? EMPTY_STRING, tradingName ?? EMPTY_STRING];

export const byThirdPartyName = (
  first: Readonly<ThirdPartyNames>,
  second: Readonly<ThirdPartyNames>,
): number => {
  const secondKey = sortKeyOf(second);

  return sortKeyOf(first).reduce(
    (comparison, part, index) =>
      comparison || collator.compare(part, secondKey[index] ?? EMPTY_STRING),
    0,
  );
};

export const sortedByThirdPartyName = <T extends Readonly<ThirdPartyNames>>(
  thirdParties: readonly T[],
): readonly T[] => [...thirdParties].sort(byThirdPartyName);
